import { baseApi } from '@/shared/api'
import type {
  ExchangeOutbox,
  ExchangeOutboxQuery,
  ExchangeQuarantine,
  ExchangeQuarantineQuery,
  ExchangeStatus,
} from '../model/types'

export const exchangeApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Сводка состояния обмена (`GET /v1/exchange/status`): очередь, ошибки, карантин, отметки
     * времени. Все величины считает бэкенд. Отдельный тег: обновляется сам по себе, не списком.
     */
    getExchangeStatus: build.query<ExchangeStatus, void>({
      query: () => ({ url: '/exchange/status' }),
      providesTags: [{ type: 'Exchange', id: 'STATUS' }],
    }),

    /**
     * Исходящие сообщения (`GET /v1/exchange/outbox`). Порядок, поиск, страница и итоги — на
     * сервере (правило 11): параметры уходят как есть, их имена — имена ручки.
     */
    getExchangeOutbox: build.query<ExchangeOutbox, ExchangeOutboxQuery>({
      query: (params) => ({ url: '/exchange/outbox', params }),
      providesTags: (res) => [
        { type: 'Exchange', id: 'OUTBOX' },
        ...(res?.items ?? []).map((item) => ({ type: 'Exchange' as const, id: `outbox:${item.id}` })),
      ],
    }),

    /** Карантин входящих (`GET /v1/exchange/quarantine`). Параметры и правила — как у исходящих. */
    getExchangeQuarantine: build.query<ExchangeQuarantine, ExchangeQuarantineQuery>({
      query: (params) => ({ url: '/exchange/quarantine', params }),
      providesTags: (res) => [
        { type: 'Exchange', id: 'QUARANTINE' },
        ...(res?.items ?? []).map((item) => ({
          type: 'Exchange' as const,
          id: `quarantine:${item.id}`,
        })),
      ],
    }),
  }),
})

export const {
  useGetExchangeStatusQuery,
  useGetExchangeOutboxQuery,
  useGetExchangeQuarantineQuery,
} = exchangeApi
